// extracted by mini-css-extract-plugin
module.exports = {"passengers":"_3A-UmzF2t8s7","passenger":"_2XKa4cmVt-Vg"};